import { postProductStatus, getProductStatus } from '../services/Api';

const createProductStatus = async ( productStatusData ) => {
    try {
        const response = await postProductStatus( productStatusData );
        return response;
    } catch (err) {
        console.log("err to save product status ", err)
        return null;
    }
};

const findProductStatusByStoreId = async ( storeId ) => {
    try {
        const response = await getProductStatus( storeId );
        return response;
    } catch (err) {
        console.log("err to get product status ", err)
        return null;
    }
};

export {
    createProductStatus,
    findProductStatusByStoreId,
 };